/**
 * Copyright (C) 2026 alaraajavamma <aki@urheiluaki.fi>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

import { PriceTagItem } from './types';

// Esiasetetut mallituotteet hintalappujärjestelmää varten.
// Nämä ladataan sovelluksen käynnistyessä ensimmäistä kertaa tai jos käyttäjä tyhjentää listan.
export const DEFAULT_TAG_ITEMS: PriceTagItem[] = [
  {
    id: '1',
    title: 'Air Zoom Pegasus 40',
    brand: 'Nike',
    category: 'JUOKSUKENKÄ',
    priceNormal: '149,90',
    priceSale: '99,90',
    sizeRange: '41-46',
    colorInfo: 'Musta/Oranssi',
    extraBadge: 'TARJOUS',
    productCode: '102-45231',
    description: 'Huipputason vaimennus ja istuvuus päivittäiseen juoksuun.'
  },
  {
    id: '2',
    title: 'W Classic Down Jacket',
    brand: 'Peak Performance',
    category: 'Naisten untuvatakki',
    priceNormal: '299,00',
    priceSale: '219,00',
    sizeRange: 'XS-XL',
    colorInfo: 'Tummansininen',
    extraBadge: 'TARJOUS',
    productCode: '852-19283',
    description: 'Erittäin lämmin ja kevyt untuvatakki säänkestävällä pintamateriaalialla.'
  },
  {
    id: '3',
    title: 'Tiro Pro Jalkapallo',
    brand: 'adidas',
    category: 'Jalkapallovarusteet',
    priceNormal: '34,90',
    priceSale: '',
    sizeRange: 'Koko 5',
    colorInfo: 'Valkoinen/Musta',
    extraBadge: 'SUOSITELTU',
    productCode: '404-98172',
    description: 'Virallinen ottelupallo talven ja kesän harjoituksiin.'
  },
  {
    id: '4',
    title: 'Helium Hood Jacket',
    brand: 'Peak Performance',
    category: 'Miesten kevytuntuvatakki',
    priceNormal: '269,90',
    priceSale: '189,90',
    sizeRange: 'S-XXL',
    colorInfo: 'Vihreä / Black',
    extraBadge: 'UUTUUS',
    productCode: '852-55212',
    description: 'Monikäyttöinen, pieneen tilaan pakkautuva premium-kevytuntuvatakki.'
  },
  {
    id: '5',
    title: 'Terrex Free Hiker 2',
    brand: 'adidas',
    category: 'Ulkoilujalkineet',
    priceNormal: '219,90',
    priceSale: '149,90',
    sizeRange: '39-47',
    colorInfo: 'Harmaa/Keltainen',
    extraBadge: 'SUPERETU',
    productCode: '202-88172',
    description: 'Vedenpitävä vaelluskenkä pitkiin ja haastaviin maastoihin.'
  },
  {
    id: '6',
    title: 'Active Joogamatto 4mm',
    brand: 'Energetics',
    category: 'Kuntoiluvälineet',
    priceNormal: '24,90',
    priceSale: '',
    sizeRange: '173 x 61 cm',
    colorInfo: 'Laventeli',
    extraBadge: '',
    productCode: '601-33129',
    description: 'Luistamaton ja kestävä joogamatto kotiharjoitteluun.'
  }
];
